// BardooTech - Single-file React App (App.jsx)
// Dependências: React, TailwindCSS (pré-configurado), lucide-react (opcional), framer-motion (opcional)
// Como usar: crie um projeto React + Tailwind, coloque este arquivo em src/App.jsx, substitua o caminho do logo em `logoSrc`.

import React, {useState} from 'react'

const logoSrc = '/bardoo_white.png' // substitua pelo caminho real da sua logo

export default function App(){
  const [menuOpen, setMenuOpen] = useState(false)
  const [loginOpen, setLoginOpen] = useState(false)

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0f172a] via-[#071024] to-[#071026] text-gray-100 font-sans">
      <header className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 bg-white/5 rounded flex items-center justify-center">
            <img src={logoSrc} alt="BardooTech" className="w-12 h-12 object-contain" />
          </div>
          <div>
            <h1 className="text-2xl font-extrabold tracking-tight">Bardoo<span className="text-red-500">Tech</span></h1>
            <p className="text-xs text-gray-400 -mt-1">Assistência Técnica Personalizada — Tecnologia & Magia</p>
          </div>
        </div>

        <nav className="hidden md:flex gap-6 items-center text-sm">
          <a href="#home" className="hover:text-red-400">Home</a>
          <a href="#quem-somos" className="hover:text-red-400">Quem somos</a>
          <a href="#servicos" className="hover:text-red-400">Nossos serviços</a>
          <a href="#planos" className="hover:text-red-400">Planos para empresas</a>
          <a href="#contato" className="hover:text-red-400">Fale conosco</a>
          <a href="#trabalhe" className="hover:text-red-400">Trabalhe conosco</a>
          <button onClick={()=>setLoginOpen(true)} className="bg-red-500 text-white px-3 py-1 rounded text-sm">Área de login</button>
        </nav>

        <button className="md:hidden" onClick={()=>setMenuOpen(!menuOpen)} aria-label="menu">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
          </svg>
        </button>
      </header>

      {menuOpen && (
        <div className="md:hidden bg-[#071022] px-6 py-4">
          <div className="flex flex-col gap-3">
            <a href="#home" className="hover:text-red-400">Home</a>
            <a href="#quem-somos" className="hover:text-red-400">Quem somos</a>
            <a href="#servicos" className="hover:text-red-400">Nossos serviços</a>
            <a href="#planos" className="hover:text-red-400">Planos para empresas</a>
            <a href="#contato" className="hover:text-red-400">Fale conosco</a>
            <a href="#trabalhe" className="hover:text-red-400">Trabalhe conosco</a>
            <button onClick={()=>setLoginOpen(true)} className="bg-red-500 text-white px-3 py-1 rounded text-sm mt-2">Área de login</button>
          </div>
        </div>
      )}

      <main className="max-w-6xl mx-auto px-6 py-12 space-y-16">

        {/* HERO / HOME */}
        <section id="home" className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-extrabold leading-tight">BardooTech — <span className="text-red-400">Tecnologia</span> com toque de <span className="text-indigo-400">magia</span></h2>
            <p className="mt-4 text-gray-300 max-w-xl">Manutenção de computadores e notebooks, suporte para empresarial e pessoal e soluções de infraestrutura. Atendimento rápido, seguro e transparente — buscamos e entregamos seu equipamento. Aceitamos cartão (parcelamos), PIX e dinheiro</p>

            <div className="mt-6 flex gap-3">
              <a href="#contato" className="bg-red-500 px-4 py-2 rounded shadow">Peça um orçamento</a>
              <a href="#planos" className="border border-gray-600 px-4 py-2 rounded">Ver planos para empresas</a>
            </div>

            <ul className="mt-8 grid grid-cols-2 gap-2 text-sm text-gray-300 max-w-md">
              <li>✔️ Formatação Windows 10/11</li>
              <li>✔️ Backup até 500GB</li>
              <li>✔️ Limpeza interna e troca de pasta térmica</li>
              <li>✔️ Teste de hardware e troca de peças</li>
            </ul>

          </div>

          <div className="bg-white/3 rounded p-6">
            <div className="h-64 flex items-center justify-center">
              <div className="text-center">
                <div className="text-5xl font-bold">
                  {/*<img src="bardoo_hand.jpeg" alt="Mãos digitando em um teclado de computador"/>*/}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* QUEM SOMOS */}
        <section id="quem-somos" className="bg-white/2 rounded p-6">
          <h3 className="text-2xl font-semibold">Quem somos</h3>
          <p className="mt-3 text-gray-200">A BardooTech nasceu para unir expertise técnica e atendimento humano. Atuamos em Guanhães/MG e região com atendimento residencial e empresarial. Nossa missão: manter seus equipamentos seguros, rápidos e confiáveis — sem mistério.</p>

          <div className="mt-4 grid md:grid-cols-3 gap-4">
            <Card title="Profissionais experientes" text="Técnicos qualificados com processos de atendimento claros." />
            <Card title="Transparência" text="Comprovante de retirada, fotos e orçamento antes de qualquer serviço." />
            <Card title="Flexibilidade" text="Retirada e entrega + várias formas de pagamento." />
          </div>
        </section>

        {/* SERVIÇOS */}
        <section id="servicos">
          <h3 className="text-2xl font-semibold">Nossos serviços</h3>
          <p className="mt-2 text-gray-300">Atendimento completo para computadores e notebooks — do software ao hardware.</p>

          <div className="mt-6 grid md:grid-cols-3 gap-6">
            <ServiceCard title="Formatação Windows 10/11" items={[
              'Backup de arquivos até 500GB',
              'Formatação e instalação do Windows',
              'Atualizações de drivers e softwares',
              'Limpeza de arquivos temporários e disco'
            ]} />

            <ServiceCard title="Manutenção preventiva/corretiva" items={[
              'Verificação e otimização do sistema',
              'Planos regulares de manutenção',
              'Relatório de saúde do parque de máquinas'
            ]} />

            <ServiceCard title="Hardware & Limpeza" items={[
              'Teste de hardware',
              'Instalação / troca de peças',
              'Limpeza interna e troca de pasta térmica',
              'Troca da bateria da BIOS e lubrificação de coolers'
            ]} />
          </div>
        </section>

        {/* PLANOS PARA EMPRESAS */}
        <section id="planos" className="bg-white/3 rounded p-6">
          <h3 className="text-2xl font-semibold">Planos para empresas</h3>
          <p className="mt-2 text-gray-300">Planos pensados para reduzir paradas e manter a operação sempre ativa. Escolha conforme o porte da sua empresa.</p>

          <div className="mt-6 grid md:grid-cols-3 gap-6">
            <PlanCard name="Básico" price="R$ 25/mês por máquina" bullets={['1 suporte preventivo','Formatação','Suporte via WhatsApp']} />
            <PlanCard name="Premium" price="R$ 50/mês por máquina" bullets={['1 suporte preventivo','Formatação','Suporte via WhatsApp','Troca de peças','Limpeza','Relatório trimestral']} highlight />
            <PlanCard name="Master" price="Sob consulta" bullets={['1 suporte preventivo','Formatação','Suporte via WhatsApp','Troca de peças','Limpeza','Relatório trimestral','Atendimento prioritário','Consultoria de infra']} />
          </div>
        </section>

        {/* FALE CONOSCO */}
        <section id="contato" className="rounded p-6 bg-gradient-to-r from-[#071022] to-[#071028]">
          <h3 className="text-2xl font-semibold">Fale conosco</h3>
          <p className="mt-2 text-gray-300">Peça um orçamento sem compromisso — retornamos em até 24 horas úteis.</p>

          <div className="mt-6 grid md:grid-cols-2 gap-6">
            <form className="space-y-3" onSubmit={(e)=>{e.preventDefault(); alert('Formulário enviado (placeholder)')}}>
              <input className="w-full p-3 rounded bg-white/5" placeholder="Nome completo" required />
              <input className="w-full p-3 rounded bg-white/5" placeholder="Telefone / WhatsApp" required />
              <input className="w-full p-3 rounded bg-white/5" placeholder="E-mail" />
              <textarea className="w-full p-3 rounded bg-white/5" placeholder="Descreva o problema / serviço desejado" rows={4}></textarea>
              <div className="flex gap-3">
                <button className="bg-red-500 px-4 py-2 rounded">Solicitar orçamento</button>
                <a type="button" className="border border-gray-600 px-4 py-2 rounded" href="https://wa.me/message/VT7YSMRXIMESH1" target="_blank" rel="noreferrer">Chamar no WhatsApp</a>
              </div>
            </form>

            <div className="space-y-3">
              <div className="bg-white/5 p-4 rounded">
                <div className="text-sm text-gray-300">Contatos:</div>
                <div className="font-medium mt-1">Telefone: (XX) XXXXX-XXXX</div>
                <div className="font-medium">E-mail: contato@bardootech.com</div>
                <div className="text-sm text-gray-400 mt-2">Aceitamos cartão (parcelamos conforme o valor), PIX e dinheiro. Retiramos e entregamos seu equipamento.</div>
              </div>

              <div className="bg-white/5 p-4 rounded">
                <h4 className="font-semibold">Endereço</h4>
                <div className="text-gray-300">Guanhães/MG</div>
              </div>
            </div>
          </div>
        </section>

        {/* TRABALHE CONOSCO */}
        <section id="trabalhe" className="rounded p-6 bg-white/2">
          <h3 className="text-2xl font-semibold">Trabalhe conosco</h3>
          <p className="mt-2 text-gray-300">Se você é técnico(a) ou tem interesse em atendimento ao cliente, envie seu currículo e portfólio.</p>

          <form className="mt-4 grid md:grid-cols-2 gap-4" onSubmit={(e)=>{e.preventDefault(); alert('Candidatura enviada (placeholder)')}}>
            <input className="w-full p-3 rounded bg-white/5" placeholder="Nome completo" required />
            <input className="w-full p-3 rounded bg-white/5" placeholder="Telefone" required />
            <input className="w-full p-3 rounded bg-white/5" placeholder="E-mail" />
            <input className="w-full p-3 rounded bg-white/5" placeholder="Área de interesse" />
            <textarea className="w-full p-3 rounded bg-white/5 md:col-span-2" placeholder="Conte um pouco sobre você / experiência" rows={4}></textarea>
            <div className="md:col-span-2"><button className="bg-red-500 px-4 py-2 rounded">Enviar candidatura</button></div>
          </form>
        </section>

        <footer className="py-8 text-center text-gray-400">© {new Date().getFullYear()} BardooTech — Assistência Técnica Personalizada • Guanhães/MG</footer>

      </main>

      {/* LOGIN MODAL (simples) */}
      {loginOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center">
          <div className="bg-white/5 p-6 rounded w-full max-w-md">
            <h4 className="text-lg font-semibold">Área de login</h4>
            <p className="text-sm text-gray-300">Login de clientes/empresas (placeholder)</p>
            <form className="mt-4" onSubmit={(e)=>{e.preventDefault(); alert('Login (placeholder)')}}>
              <input className="w-full p-3 rounded bg-white/5 mb-2" placeholder="E-mail" />
              <input className="w-full p-3 rounded bg-white/5 mb-2" placeholder="Senha" type="password" />
              <div className="flex justify-end gap-2">
                <button type="button" onClick={()=>setLoginOpen(false)} className="px-3 py-1 border rounded">Fechar</button>
                <button className="bg-red-500 px-4 py-1 rounded">Entrar</button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  )
}


/* ---------- Componentes auxiliares ---------- */
function Card({title, text}){
  return (
    <div className="bg-white/5 p-4 rounded">
      <h5 className="font-semibold">{title}</h5>
      <p className="text-sm text-gray-300 mt-2">{text}</p>
    </div>
  )
}

function ServiceCard({title, items}){
  return (
    <div className="bg-white/4 p-4 rounded">
      <h4 className="font-semibold">{title}</h4>
      <ul className="mt-3 text-sm text-gray-300 space-y-1">
        {items.map((it,i)=> <li key={i}>• {it}</li>)}
      </ul>
    </div>
  )
}

function PlanCard({name, price, bullets, highlight}){
  return (
    <div className={`p-4 rounded border ${highlight ? 'border-red-500 bg-white/6' : 'border-gray-700 bg-white/4'}`}>
      <div className="flex items-center justify-between">
        <div>
          <h4 className="font-semibold">{name}</h4>
          <div className="text-sm text-gray-300">{price}</div>
        </div>
        {highlight && <div className="text-sm text-red-400 font-semibold">Mais popular</div>}
      </div>
      <ul className="mt-3 text-sm text-gray-300 space-y-1">
        {bullets.map((b,i)=>(<li key={i}>• {b}</li>))}
      </ul>
      <div className="mt-4">
        <button className="bg-red-500 px-3 py-2 rounded">Quero esse plano</button>
      </div>
    </div>
  )
}
